define('presentation/settings/integrations/viewModels/integrationsViewModel',[
    'common/collections/collectionFilter',
    'common/collections/collectionSorter',
    'common/promises/promiseFactory',
    'constants/integrationsConstants',
    'presentation/common/window/windowControl',
    'presentation/settings/integrations/facades/integrationsFacade',
    'presentation/settings/integrations/viewModels/addClioGrowTokenModalViewModel',
    'presentation/settings/integrations/viewModels/removeIntegrationModalViewModel',
], function(){
    return function() {
        const self = this;

        const FilterConstructor = require('common/collections/collectionFilter');
        const SorterConstructor = require('common/collections/collectionSorter');

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _windowControl = require('presentation/common/window/windowControl');

        const _integrationsConstants = require('constants/integrationsConstants');

        const CONFIRM_RESPONSE = "yes";
        const ActionModalViewModelConstructor = require('presentation/common/actionModal/viewModels/actionModalViewModel');
        self.actionModal = new ActionModalViewModelConstructor();

        const AddClioGrowTokenModalConstructor = require('presentation/settings/integrations/viewModels/addClioGrowTokenModalViewModel');
        const RemoveIntegrationModalConstructor = require('presentation/settings/integrations/viewModels/removeIntegrationModalViewModel');

        let _availableIntegrations = null;
        let _disposables = [];
        let _facade = null;

        const _integrationsFilterOnChange = () => {
            _updateDisplayedIntegrations();
        };

        const _refreshIntegrations = () => {
            return _promiseFactory.defer((promise) => {
                _facade.getIntegrations()
                    .done((integrations) => {
                        _availableIntegrations = integrations;
                        _updateDisplayedIntegrations();
                        promise.resolve();
                    });
            });
        };

        const _sortDisplayedIntegrations = () => {
            let sorter = new SorterConstructor();
            if (sorter.setOptions(self.sortOptions(), self.sortType())) {
                sorter.sort(self.displayIntegrations);
            }
        };

        const _updateDisplayedIntegrations = () => {
            let filteredIntegrations;
            const filterContent = self.integrationsFilter().trim().toLowerCase();
            if (filterContent) {
                const integrationsFilter = new FilterConstructor();
                integrationsFilter.addProperty('name');
                integrationsFilter.addProperty('isConnected');
                integrationsFilter.addValue(filterContent);
                filteredIntegrations = integrationsFilter.filter(_availableIntegrations);
            }
            else {
                filteredIntegrations = _availableIntegrations;
            }
            self.displayIntegrations(filteredIntegrations);
            _sortDisplayedIntegrations();
        };

        self.isCompositionComplete = ko.observable(false);
        self.displayIntegrations = ko.observableArray([]);
        self.sortOptions = ko.observableArray([
            {textI18n: "name", iconName: 'sortName', sortPath : "name", isAscending : true},
            {textI18n: "integrationStatus", iconName: 'integration', sortPath : "isConnected", isAscending : false}
        ]);
        self.sortType = ko.observable("name");
        _disposables.push(self.sortType.subscribe(_sortDisplayedIntegrations));
        self.integrationsFilter = ko.observable('');
        _disposables.push(self.integrationsFilter.subscribe(_integrationsFilterOnChange));
        self.showResults = ko.pureComputed(() => self.displayIntegrations().length > 0);

        self.onConnect = (integrationPresentationObject) => {
            if (integrationPresentationObject.platformId === _integrationsConstants.clioGrow) {
                _showAddClioGrowTokenModal();
            }
            else {
                _windowControl.openNewWindow(integrationPresentationObject.oauthUrl, "_self");
            }
        };

        const _showAddClioGrowTokenModal = () => {
            _buildAddClioGrowTokenModal();

            self.actionModal.showModal()
                .done((result) => {
                    _refreshIntegrations();
                })
                .fail((error) => {
                    throw error;
                });
        };

        const _buildAddClioGrowTokenModal = () => {
            const constructorParams = [];
            self.actionModal
                .clearModal()
                .setContentViewModel(AddClioGrowTokenModalConstructor, constructorParams)
                .setHeaderText({i18n: 'addClioGrowTokenModal:addClioGrowToken'})
                .setSubmitButtonText({i18n: 'save'});
        };

        self.onRemove = (integrationPresentationObject) => {
            _showRemoveIntegrationModal(integrationPresentationObject);
        };

        const _showRemoveIntegrationModal = (integrationPresentationObject) => {
            _buildRemoveIntegrationModal(integrationPresentationObject);

            self.actionModal.showModal()
                .done((result) => {
                    if (result === CONFIRM_RESPONSE) {
                        _removeIntegration(integrationPresentationObject);
                    }
                })
                .fail((error) => {
                    throw error;
                });
        };

        const _buildRemoveIntegrationModal = (integrationPresentationObject) => {
            const constructorParams = [integrationPresentationObject];
            self.actionModal
                .clearModal()
                .setContentViewModel(RemoveIntegrationModalConstructor, constructorParams)
                .setHeaderText({i18n: 'removeIntegrationModal:removeIntegration'})
                .setSubmitButtonText({i18n: 'remove'});
        };

        const _removeIntegration = (integrationPresentationObject) => {
            return _promiseFactory.defer((promise) => {
                _facade.removeIntegration(integrationPresentationObject.platformId)
                    .done(() => {
                        promise.resolve();

                        _refreshIntegrations();
                    })
                    .fail((error) => {
                        error.name = integrationPresentationObject.name;
                        throw error;
                    });
            });
        };

        self.compositionComplete = () => {
            self.isCompositionComplete(true);
        };

        self.detached = () => {
            _disposables.forEach(s => s.dispose);
            _disposables = [];
        };

        self.activate = () => {
            const FacadeConstructor = require('presentation/settings/integrations/facades/integrationsFacade');
            _facade = new FacadeConstructor();
            _facade.init(_promiseFactory);

            return _initialize();
        };

        const _initialize = () => {
            _refreshIntegrations();

            return _promiseFactory.wait();
        };
    };
});

